/* global gtag */
/* global fbq */

import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { format,parse } from 'date-fns';
import { getEligibility } from '../../Utils/api';
import { updateCustomerDetails, updateJourneyEvents } from '../../CustomerJourneyDetails/CustomerJourneyDetails';
import MobileNav from '../../component/MobileNav';
import { formatDobArray } from '../../helpers/global.helpers';
import JourneyRightPanel from '../../component/JourneyRightPannel';


const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

  .emp-page * { box-sizing: border-box; margin: 0; padding: 0; }

  .emp-page {
    min-height: 100vh;
    background: #eaf1fd;
    display: flex;
    flex-direction: column;
    font-family: 'Sora', sans-serif;
  }

  .emp-split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    flex: 1;
    min-height: calc(100vh - 60px);
    margin-top:50px;
  }

  /* ── LEFT PANEL ── */
  .emp-left {
    display: flex;
    flex-direction: column;
    padding: 3rem 3.5rem;
    background: #eaf1fd;
    overflow-y: auto;
  }

  .emp-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 2.5rem;
    flex-shrink: 0;
  }
  .emp-logo-dot {
    width: 34px; height: 34px;
    background: #F97316;
    border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
  }
  .emp-logo-dot svg { width: 18px; height: 18px; fill: none; stroke: #fff; stroke-width: 2.2; stroke-linecap: round; }
  .emp-logo-name { font-size: 16px; font-weight: 600; color: #0f1c2e; letter-spacing: -0.2px; }

  .emp-card {
    background: #ffffff;
    border-radius: 24px;
    padding: 2.25rem 2.5rem;
    box-shadow: 0 4px 40px rgba(15,28,46,0.08), 0 1px 4px rgba(15,28,46,0.04);
    border: 1px solid rgba(255,255,255,0.8);
    flex: 1;
  }

  .emp-card-title {
    font-size: 22px; font-weight: 700;
    color: #0f1c2e; letter-spacing: -0.5px; margin-bottom: 4px;
  }
  .emp-card-sub {
    font-size: 13px; color: #6b7a90; margin-bottom: 2rem;
  }

  /* SECTION DIVIDERS */
  .emp-section {
    margin-bottom: 1.75rem;
  }
  .emp-section-title {
    font-size: 11px; font-weight: 600; letter-spacing: 0.7px;
    text-transform: uppercase; color: #9aaabb;
    margin-bottom: 1rem;
    display: flex; align-items: center; gap: 8px;
  }
  .emp-section-title::after {
    content: '';
    flex: 1; height: 1px; background: #e8eef7;
  }

  /* GRID ROW */
  .emp-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.25rem;
    margin-bottom: 1.25rem;
  }

  /* RADIO GROUP */
  .emp-field-label {
    font-size: 11px; font-weight: 600; letter-spacing: 0.5px;
    text-transform: uppercase; color: #6b7a90;
    margin-bottom: 10px; display: block;
  }
  .emp-field-label .req { color: #F97316; }

  .emp-radio-group {
    display: flex; gap: 8px; flex-wrap: wrap;
  }
  .emp-radio-btn {
    display: flex; align-items: center; gap: 7px;
    padding: 9px 14px;
    border: 1.5px solid #dce4f0;
    border-radius: 10px;
    background: #f7f9fc;
    cursor: pointer;
    font-family: 'Sora', sans-serif;
    font-size: 13px; font-weight: 500; color: #4a5568;
    transition: border-color 0.15s, background 0.15s, color 0.15s;
    user-select: none;
  }
  .emp-radio-btn:hover { border-color: #b8cce8; background: #fff; }
  .emp-radio-btn.active {
    border-color: #F97316;
    background: rgba(249,115,22,0.06);
    color: #F97316;
  }
  .emp-radio-dot {
    width: 14px; height: 14px; border-radius: 50%;
    border: 2px solid #c8d3e2;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0; transition: border-color 0.15s;
  }
  .emp-radio-btn.active .emp-radio-dot { border-color: #F97316; }
  .emp-radio-dot-inner {
    width: 6px; height: 6px; border-radius: 50%;
    background: #F97316; opacity: 0;
    transition: opacity 0.15s;
  }
  .emp-radio-btn.active .emp-radio-dot-inner { opacity: 1; }

  /* BOX INPUTS (Pincode / DOB) */
  .emp-boxes-wrap {
    display: flex; gap: 5px; align-items: center;
  }
  .emp-box {
    width: 36px; height: 44px;
    border: 1.5px solid #dce4f0;
    border-radius: 10px;
    background: #f7f9fc;
    text-align: center;
    font-family: 'JetBrains Mono', monospace;
    font-size: 15px; font-weight: 500; color: #0f1c2e;
    outline: none; caret-color: transparent;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  }
  .emp-box::placeholder { color: #c8d3e2; }
  .emp-box:focus {
    border-color: #378ADD; background: #fff;
    box-shadow: 0 0 0 3px rgba(55,138,221,0.14);
  }
  .emp-box.has-val { border-color: #b8cce8; background: #fff; }
  .emp-box.emp-err { border-color: #E24B4A; background: #fff9f9; box-shadow: 0 0 0 3px rgba(226,75,74,0.1); }
  .emp-dob-sep {
    font-size: 16px; color: #9aaabb; font-weight: 300;
    margin: 0 2px; flex-shrink: 0;
  }

  /* TEXT / EMAIL INPUTS */
  .emp-input-wrap { position: relative; }
  .emp-input-icon {
    position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
    color: #9aaabb; pointer-events: none;
    display: flex; align-items: center;
  }
  .emp-input-icon svg { width: 16px; height: 16px; }
  .emp-input {
    width: 100%; height: 46px;
    border: 1.5px solid #dce4f0; border-radius: 12px;
    background: #f7f9fc;
    padding: 0 14px 0 38px;
    font-family: 'Sora', sans-serif;
    font-size: 14px; font-weight: 400; color: #0f1c2e;
    outline: none;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  }
  .emp-input::placeholder { color: #adb8ca; }
  .emp-input:focus {
    border-color: #378ADD; background: #fff;
    box-shadow: 0 0 0 3px rgba(55,138,221,0.14);
  }
  .emp-input.emp-err { border-color: #E24B4A; background: #fff9f9; box-shadow: 0 0 0 3px rgba(226,75,74,0.1); }

  /* ERROR MESSAGE */
  .emp-error-msg {
    display: flex; align-items: center; gap: 5px;
    font-size: 12px; color: #E24B4A; margin-top: 6px;
  }
  .emp-error-msg svg { width: 13px; height: 13px; flex-shrink: 0; }

  /* CTA */
  .emp-cta {
    width: 100%; height: 50px;
    border: none; border-radius: 14px;
    background: #F97316; color: #fff;
    font-family: 'Sora', sans-serif;
    font-size: 15px; font-weight: 600;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 8px;
    transition: background 0.18s, transform 0.1s, box-shadow 0.18s;
    box-shadow: 0 4px 18px rgba(249,115,22,0.32);
    letter-spacing: -0.1px;
    margin-top: 1.75rem;
  }
  .emp-cta:hover:not(:disabled) {
    background: #ea6a0a;
    box-shadow: 0 6px 24px rgba(249,115,22,0.42);
    transform: translateY(-1px);
  }
  .emp-cta:active:not(:disabled) { transform: scale(0.98); }
  .emp-cta:disabled { background: #c8d3e2; box-shadow: none; cursor: not-allowed; }
  .emp-cta svg { width: 17px; height: 17px; }

  /* TRUST BAR */
  .emp-trust {
    display: flex; align-items: center; justify-content: center;
    gap: 6px; margin-top: 1.25rem;
    font-size: 11.5px; color: #9aaabb;
  }
  .emp-trust svg { width: 13px; height: 13px; }
  .emp-trust-sep { width: 3px; height: 3px; background: #c8d3e2; border-radius: 50%; margin: 0 2px; }

  /* RESPONSIVE */
  @media (max-width: 900px) {
    .emp-split { grid-template-columns: 1fr; }
    .emp-left { padding: 2rem 1.25rem 6rem; }
    .emp-logo { margin-bottom: 1.5rem; }
    .emp-card { padding: 1.75rem 1.5rem; }
    .emp-row { grid-template-columns: 1fr; gap: 1rem; }
    .emp-box { width: 32px; height: 40px; font-size: 14px; }
  }

  @media (max-width: 400px) {
    .emp-card { padding: 1.5rem 1.25rem; }
    .emp-box { width: 28px; height: 38px; font-size: 13px; border-radius: 8px; }
    .emp-radio-btn { padding: 8px 11px; font-size: 12px; }
  }
`;

const IconBolt = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);
const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);
const IconArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
const IconAlert = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);
const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

// Reusable Radio Button
const RadioBtn = ({ label, value, selected, onChange }) => (
  <div
    className={`emp-radio-btn ${selected === value ? 'active' : ''}`}
    onClick={() => onChange(value)}
    role="radio"
    aria-checked={selected === value}
    tabIndex={0}
    onKeyDown={e => e.key === 'Enter' && onChange(value)}
  >
    <span className="emp-radio-dot">
      <span className="emp-radio-dot-inner" />
    </span>
    {label}
  </div>
);

// Error message
const ErrMsg = ({ msg }) => msg ? (
  <p className="emp-error-msg"><IconAlert /> {msg}</p>
) : null;

export default function EmploymentDetail() {
  const [empType, setempType] = useState('');
  const [salMode, setsalMode] = useState('');
  const [resType, setresType] = useState('');
  const [mailid, setmailId] = useState('');
  const [officialEmail, setOfficialEmail] = useState('');
  const [pincode, setPincode] = useState([]);
  const [dob, setDob] = useState([]);
  const [errors, setErrors] = useState({});
  const [genderType, setGenderType] = useState('');
  const [loader, setLoader] = useState(false);
  
  const dispatch = useDispatch();
  const customerDetails = useSelector((state) => state.customerJourneyDetails.customerDetails);
  const navigate = useNavigate();
  const pinRefs = useRef([]);
  const dobRefs = useRef([]);
  const click_Id = useSelector((state) => state.customerJourneyDetails.click_id);
  const utm_source = customerDetails?.utm_source;
  const utm_campaign = customerDetails?.utm_campaign;
  const [nextSalaryDate, setNextSalaryDate] = useState('');

  useEffect(() => {
    if (customerDetails?.gender === 'Male') setGenderType('1');
    else if (customerDetails?.gender === 'Female') setGenderType('2');

    if (customerDetails) {
      setPincode(
        customerDetails?.residence_pincode
          ? String(customerDetails.residence_pincode).split('')
          : []
      );
      setmailId(customerDetails?.personal_email || '');
      setOfficialEmail(customerDetails?.office_email || '');
      setresType(customerDetails?.residence_type_id || '');
      setsalMode(Number(customerDetails?.salary_mode_id) || '');
      setempType(customerDetails?.income_type_id || '');
    }

    if (customerDetails?.dob) {
      const formatted = format(new Date(customerDetails.dob), 'ddMMyyyy');
      setDob(formatted.split(''));
    }
  }, [customerDetails]);

  // Pincode handlers
  const handlePincodeChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    const newPin = [...pincode];
    newPin[index] = value;
    setPincode(newPin);
    if (value && index < 5) pinRefs.current[index + 1]?.focus();
  };
  const handlePincodeKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (pincode[index]) {
        const newPin = [...pincode]; newPin[index] = ''; setPincode(newPin);
      } else if (index > 0) pinRefs.current[index - 1]?.focus();
    } else if (e.key === 'ArrowLeft' && index > 0) pinRefs.current[index - 1]?.focus();
    else if (e.key === 'ArrowRight' && index < 5) pinRefs.current[index + 1]?.focus();
  };

  // DOB handlers
  const handleDobChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    const newDob = [...dob]; newDob[index] = value; setDob(newDob);
    if (value && index < 7) dobRefs.current[index + 1]?.focus();
  };
  const handleDobKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (dob[index]) {
        const newDob = [...dob]; newDob[index] = ''; setDob(newDob);
      } else if (index > 0) dobRefs.current[index - 1]?.focus();
    } else if (e.key === 'ArrowLeft' && index > 0) dobRefs.current[index - 1]?.focus();
    else if (e.key === 'ArrowRight' && index < 7) dobRefs.current[index + 1]?.focus();
  };

  const validateFields = () => {
    const newErrors = {};
    if (!empType) newErrors.empType = 'Employment type is required';
    if (!salMode) newErrors.salMode = 'Salary mode is required';
    if (!resType) newErrors.resType = 'Residence type is required';
    if (!nextSalaryDate)
    newErrors.nextSalaryDate = 'Next salary date is required';
    const pincodeA = Array.isArray(pincode) ? pincode : [];
    if (!pincodeA.join('') || pincodeA.join('').length < 6)
      newErrors.pincode = 'Please enter a valid 6-digit pincode';
    if (!mailid) newErrors.mailid = 'Personal email is required';
    else if (!/^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(mailid))
      newErrors.mailid = 'Enter a valid email address';
    const dobA = Array.isArray(dob) ? dob : [];
    if (!customerDetails?.dob && !dobA.join(''))
      newErrors.dob = 'Date of birth is required';
    if (!customerDetails?.gender && !genderType)
      newErrors.gender = 'Please select your gender';
    if (officialEmail && !/^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(officialEmail))
      newErrors.officialEmail = 'Enter a valid official email address';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submit = async () => {
    if (loader) return;
    if (!validateFields()) {
      toast.error('Please fill in all mandatory details before checking eligibility.');
      return;
    }
    const param = {
      profileId: customerDetails?.profileId,
      pancard: customerDetails?.pancard,
      monthlyIncome: Number(customerDetails?.monthly_income),
      pincode: Number(pincode.join('')),
      dob: formatDobArray(dob.join('')) || customerDetails?.dob,
      sourceId: 4,
      employmentType: empType,
      salaryMode: salMode,
      residence_type: resType,
      personal_email: mailid,
      official_email: officialEmail,
      gender: genderType || customerDetails?.gender,
       nextSalaryDate: format(
          new Date(nextSalaryDate),
          'yyyy-MM-dd'
        ),
    };
    try {
      setLoader(true);
      const response = await getEligibility(param);
      if (response?.data?.apiStatus == 1) {
        toast.success(response?.data?.message);
        if (utm_source == 'Valueleaf') {
          const url = `https://pixel.whistleloop.com/pixel?click_id=${click_Id}&revenue='revenue'&goal_name=Doable`;

          fetch(url).catch(() => { });

        }
        if (utm_source === 'valueleaf_facebook') {
            try {
                if (typeof window.fbq === 'function') {
                    window.fbq('init', '360129980270706');
                    window.fbq('track', 'InitiateCheckout');

                    
                } else {
                    console.error('Meta Pixel fbq is not loaded');
                }
            } catch (error) {
                console.error('Meta Pixel error:', error);
            }
        }
       
        if (utm_source === "profuse") {

          window.fbq("init", "1372387427777189");
          window.fbq("track", "InitiateCheckout");
        }
        
          
      

        

        
        if (utm_source == 'ORGANIC') {
          gtag('event', 'conversion', {
            send_to: 'AW-17928723161/TwM1CMmZ6rQcENm1iuVC'
          });
          
        }
        dispatch(updateCustomerDetails({
          dob, residence_pincode: pincode,
          income_type_id: empType, salary_mode_id: salMode,
          personal_email: mailid, office_email: officialEmail,
          isAuto:response?.data?.isAuto
        }));
        dispatch(updateJourneyEvents({ check_eligibility: 1, loan_quote: 2 }));
      } else {

        

        navigate('/journey/not-eligible');
        toast.error(response?.data?.message);
      }
    } catch {
      toast.error('Error in CheckEligibility');
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="emp-page">
        <div className="emp-split">

          {/* ── LEFT: FORM ── */}
          <div className="emp-left">


            <div className="emp-card">
              <h1 className="emp-card-title">Basic details</h1>
              <p className="emp-card-sub">Enter your details to start your application.</p>

              {/* ── EMPLOYMENT INFO ── */}
              <div className="emp-section">
                <div className="emp-section-title">Employment info</div>
                <div className="emp-row">
                  <div>
                    <label className="emp-field-label">
                      Employment type <span className="req">*</span>
                    </label>
                    <div className="emp-radio-group">
                      <RadioBtn label="Salaried" value={1} selected={empType} onChange={v => { setempType(v); setErrors(e => ({ ...e, empType: '' })); }} />
                      <RadioBtn label="Self-Employed" value={2} selected={empType} onChange={v => { setempType(v); setErrors(e => ({ ...e, empType: '' })); }} />
                    </div>
                    <ErrMsg msg={errors.empType} />
                  </div>

                  <div>
                    <label className="emp-field-label">
                      Salary received via <span className="req">*</span>
                    </label>
                    <div className="emp-radio-group">
                      <RadioBtn label="Bank" value={1} selected={salMode} onChange={v => { setsalMode(v); setErrors(e => ({ ...e, salMode: '' })); }} />
                      <RadioBtn label="Cash" value={3} selected={salMode} onChange={v => { setsalMode(v); setErrors(e => ({ ...e, salMode: '' })); }} />
                    </div>
                    <ErrMsg msg={errors.salMode} />
                  </div>
                </div>
              </div>

              {/* ── RESIDENCE ── */}
              <div className="emp-section">
                <div className="emp-section-title">Residence</div>
                <div className="emp-row">
                  <div>
                    <label className="emp-field-label">
                      Residence type <span className="req">*</span>
                    </label>
                    <div className="emp-radio-group">
                      <RadioBtn label="Owned" value={1} selected={resType} onChange={v => { setresType(v); setErrors(e => ({ ...e, resType: '' })); }} />
                      <RadioBtn label="Rented" value={2} selected={resType} onChange={v => { setresType(v); setErrors(e => ({ ...e, resType: '' })); }} />
                    </div>
                    <ErrMsg msg={errors.resType} />
                  </div>

                  <div>
                    <label className="emp-field-label">
                      City pincode <span className="req">*</span>
                    </label>
                    <div className="emp-boxes-wrap">
                      {[...Array(6)].map((_, i) => (
                        <input
                          key={i}
                          type="text"
                          maxLength="1"
                          inputMode="numeric"
                          value={pincode[i] || ''}
                          onChange={e => handlePincodeChange(e, i)}
                          onKeyDown={e => handlePincodeKeyDown(e, i)}
                          ref={el => pinRefs.current[i] = el}
                          placeholder="0"
                          aria-label={`Pincode digit ${i + 1}`}
                          className={`emp-box ${errors.pincode ? 'emp-err' : ''} ${pincode[i] ? 'has-val' : ''}`}
                        />
                      ))}
                    </div>
                    <ErrMsg msg={errors.pincode} />
                  </div>
                </div>
              </div>

              {/* ── PERSONAL INFO (DOB + GENDER) ── */}
              {(!customerDetails?.dob || !customerDetails?.gender) && (
                <div className="emp-section">
                  <div className="emp-section-title">Personal info</div>
                  <div className="emp-row">
                    {!customerDetails?.dob && (
                      <div>
                        <label className="emp-field-label">
                          Date of birth (DD/MM/YYYY) <span className="req">*</span>
                        </label>
                        <div className="emp-boxes-wrap">
                          {[...Array(8)].map((_, i) => (
                            <React.Fragment key={i}>
                              <input
                                type="text"
                                maxLength="1"
                                inputMode="numeric"
                                value={dob[i] || ''}
                                onChange={e => handleDobChange(e, i)}
                                onKeyDown={e => handleDobKeyDown(e, i)}
                                ref={el => dobRefs.current[i] = el}
                                placeholder="0"
                                aria-label={`DOB digit ${i + 1}`}
                                className={`emp-box ${errors.dob ? 'emp-err' : ''} ${dob[i] ? 'has-val' : ''}`}
                                style={{ width: i >= 4 ? '36px' : '36px' }}
                              />
                              {(i === 1 || i === 3) && <span className="emp-dob-sep">/</span>}
                            </React.Fragment>
                          ))}
                        </div>
                        <ErrMsg msg={errors.dob} />
                      </div>
                    )}

                    {!customerDetails?.gender && (
                      <div>
                        <label className="emp-field-label">
                          Gender <span className="req">*</span>
                        </label>
                        <div className="emp-radio-group">
                          <RadioBtn label="Male" value="1" selected={genderType} onChange={v => { setGenderType(v); setErrors(e => ({ ...e, gender: '' })); }} />
                          <RadioBtn label="Female" value="2" selected={genderType} onChange={v => { setGenderType(v); setErrors(e => ({ ...e, gender: '' })); }} />
                        </div>
                        <ErrMsg msg={errors.gender} />
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* ── EMAIL ── */}
              <div className="emp-section">
                <div className="emp-section-title">Contact</div>
                <div className="emp-row">
                  <div>
                    <label className="emp-field-label" htmlFor="personalEmail">
                      Personal email <span className="req">*</span>
                    </label>
                    <div className="emp-input-wrap">
                      <span className="emp-input-icon"><IconMail /></span>
                      <input
                        id="personalEmail"
                        type="email"
                        value={mailid}
                        onChange={e => { setmailId(e.target.value); setErrors(err => ({ ...err, mailid: '' })); }}
                        className={`emp-input ${errors.mailid ? 'emp-err' : ''}`}
                        placeholder="you@example.com"
                      />
                    </div>
                    <ErrMsg msg={errors.mailid} />
                  </div>

                  <div>
                    <label className="emp-field-label" htmlFor="officialEmail">
                      Official email
                    </label>
                    <div className="emp-input-wrap">
                      <span className="emp-input-icon"><IconMail /></span>
                      <input
                        id="officialEmail"
                        type="email"
                        value={officialEmail}
                        onChange={e => { setOfficialEmail(e.target.value); setErrors(err => ({ ...err, officialEmail: '' })); }}
                        className={`emp-input ${errors.officialEmail ? 'emp-err' : ''}`}
                        placeholder="work@company.com"
                      />
                    </div>
                    <ErrMsg msg={errors.officialEmail} />
                  </div>
                </div>
              </div>
              <div className="emp-section">
                <div className="emp-section-title">Salary Information</div>

                <div>
                  <label className="emp-field-label">
                    Next Salary Date <span className="req">*</span>
                  </label>

                  <input
                    type="date"
                    min={format(new Date(), 'yyyy-MM-dd')}
                    value={nextSalaryDate}
                    onChange={(e) => {
                      setNextSalaryDate(e.target.value);
                      setErrors(err => ({
                        ...err,
                        nextSalaryDate: ''
                      }));
                    }}
                    className={`emp-input ${
                      errors.nextSalaryDate ? 'emp-err' : ''
                    }`}
                  />

                  <ErrMsg msg={errors.nextSalaryDate} />
                </div>
              </div>

              {/* CTA */}
              <button className="emp-cta" onClick={submit} disabled={loader}>
                {loader ? (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
                      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
                        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite" />
                      </path>
                    </svg>
                    Checking eligibility…
                  </>
                ) : (
                  <>
                    Check eligibility
                    <IconArrow />
                  </>
                )}
              </button>

              <div className="emp-trust">
                <IconLock />
                256-bit SSL encrypted
                <span className="emp-trust-sep" />
                Your data is private
                <span className="emp-trust-sep" />
                RBI compliant
              </div>
            </div>
          </div>

          {/* ── RIGHT: reusable component ── */}
          <JourneyRightPanel />

        </div>
      </div>
      <MobileNav />
    </>
  );
}